/* src/app/components/doc-viewer-new/doc-viewer-context-panel-template/browse-context-panel/browse-context-panel.component.scss */
.docs {
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  font-size: 14px;
  color: black;
  cursor: pointer;
}
:host-context(.dark-theme) .docs {
  color: white;
}
.docs-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
}
.docs-node {
  margin-right: 12px;
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .docs-node {
  --fa-primary-color: #FFC107;
  --fa-secondary-color:#6d6c6c;
  --fa-secondary-opacity: 1 ;
}
.active {
  border-left: 4px solid rgb(63, 81, 181);
  background: rgba(57, 73, 171, 0.08);
  padding: 10px 18px;
}
:host-context(.dark-theme) .active {
  border-left: 4px solid #ffc107;
  background: rgba(0, 0, 0, 0.32);
}
.selected-node {
  margin-right: 12px;
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .selected-node {
  --fa-primary-color: #FFC107;
  --fa-secondary-color:#a1a1a1;
  --fa-secondary-opacity: 1 ;
}
.child {
  padding: 10px 20px 10px 45px !important;
}
.attention {
  background: rgba(0, 0, 0, 0.32);
}
/*# sourceMappingURL=browse-context-panel.component.css.map */
